export default "__VITE_ASSET__DAr2GUWF__"